export default __webpack_public_path__ + "static/media/tecnologia.d4ec30df.png";